export enum RcsBrandRegistrationStatus {
  Created = "CREATED",
  Configured = "CONFIGURED",
  Submitted = "SUBMITTED",
  Reviewing = "REVIEWING",
  Vetting = "VETTING",
  Verified = "VERIFIED",
  Rejected = "REJECTED",
  Failed = "FAILED",
}
